import React from 'react';
import styles from './footer.module.css';

interface Props {
  children: React.ReactNode;
}

export const Footer = ({ children }: Props) => {
  return <div className={styles.footer}>{children}</div>;
};
